import Vue from 'vue'
import Vuex from 'vuex'
import root from './root/root-store'
import calls from './call/calls'
import forms from './forms/forms'
import location from './location/location'
//import messaging from './messaging/messaging'
//import webmail from './webmail/webmail'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',

  state: {},
  mutations: {},
  getters: {},
  actions: {},
  modules: {
    root: root,
    calls: calls,
    location: location,
    forms: forms
    //messaging: messaging,
    //webmail: webmail
  }
})
